<template>
  <section>
    <div class="vaccination-setting-tabs" role="tablist" aria-label="Paramètres vaccination">
      <button id="vaccination-calendars-tab" type="button" role="tab" aria-controls="vaccination-calendars-panel" :aria-selected="section==='calendars' ? 'true' : 'false'" :tabindex="section==='calendars' ? 0 : -1" :class="{active:section==='calendars'}" @click="select('calendars')" @keydown.right.prevent="select('billing',true)" @keydown.left.prevent="select('billing',true)">Calendriers</button>
      <button id="vaccination-billing-tab" type="button" role="tab" aria-controls="vaccination-billing-panel" :aria-selected="section==='billing' ? 'true' : 'false'" :tabindex="section==='billing' ? 0 : -1" :class="{active:section==='billing'}" @click="select('billing')" @keydown.right.prevent="select('calendars',true)" @keydown.left.prevent="select('calendars',true)">Gratuité et acte facturé</button>
    </div>
    <p v-if="notice" class="alert alert-warning" role="status">{{ notice }}</p>
    <div v-show="section==='calendars'" id="vaccination-calendars-panel" role="tabpanel" aria-labelledby="vaccination-calendars-tab"><Calendars ref="calendars" /></div>
    <div v-show="section==='billing'" id="vaccination-billing-panel" role="tabpanel" aria-labelledby="vaccination-billing-tab"><Settings v-if="billingVisited" ref="billing" /></div>
  </section>
</template>
<script>
import Calendars from './Calendars.vue'
import Settings from './Settings.vue'
export default {
  components:{Calendars,Settings},
  data:()=>({section:'calendars',billingVisited:false,notice:''}),
  methods:{
    select(section,focus=false){
      if(section===this.section)return
      this.notice=''
      const calendars=this.$refs.calendars
      // Both editors stay mounted, so switching never discards a financial form.
      if(this.section==='calendars' && calendars && (calendars.saving || calendars.pending || calendars.confirmation)){
        this.notice='Terminez ou reprenez la demande de calendrier avant de changer d’onglet.';return
      }
      const billing=this.$refs.billing
      if(this.section==='billing' && billing && (billing.saving || billing.pending)){
        this.notice='Terminez ou reprenez l’enregistrement du paramètre financier avant de changer d’onglet.';return
      }
      this.section=section
      if(section==='billing')this.billingVisited=true
      if(focus)this.$nextTick(()=>this.$el.querySelector('#vaccination-'+section+'-tab').focus())
    }
  }
}
</script>
<style scoped>
.vaccination-setting-tabs{display:flex;flex-wrap:wrap;gap:8px;background:#fff;border-radius:14px;margin-bottom:20px;padding:0 8px}.vaccination-setting-tabs button{background:white;color:var(--ui-text-secondary,#273449);border:0;border-bottom:2px solid transparent;padding:12px 16px;min-height:44px;font:inherit}.vaccination-setting-tabs button.active{color:var(--ui-accent,#2457c5);border-bottom-color:var(--ui-accent,#2457c5)}.vaccination-setting-tabs button:focus-visible{outline:2px solid var(--ui-accent,#2457c5);outline-offset:2px}
</style>
